import { useEffect } from "react";
import { getDocument, PDFDocumentProxy } from "pdfjs-dist";
import { signatarioDadosDto } from "./signatarios.dto";
import { Button, Spinner } from "react-bootstrap";
import funcSleep from "../../../components/funcSleep";
import { defineValueInInput, getElementFromId, getValueFromInput } from "../../../components/funcForInput";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function RenderDocumentos({ handleUpdate, handleLoadingStatus }: iProps) {
    const documentoDados = useSelector((state: any) => state.uiDocumentos.documentoDados)
    const signatariosDados:signatarioDadosDto[] = parseSignatarios(documentoDados.signatarios)
    let paginasDados:any[] = []
    let assinaturasDados: any[] = []
    let assinaturasIndexCount: number = 0
    
    useEffect(() => {
        loadingDocumento()
        // eslint-disable-next-line
    }, [])
    async function loadingDocumento() { 
        let dadosAux: any[] = parseAssinaturas()
        assinaturasDados = dadosAux
        await funcSleep(150)
        renderViewDocumento()
    }
    function parseAssinaturas():any[] {
        let assinaturas_aux:any[] = []
        for (let ass of documentoDados.assinaturas) { 
            let assinatura_nova = {
                id_assinatura: ass.id_assinatura,
                id_documento: ass.id_documento,
                id_signatario: ass.id_signatario,
                index: assinaturasIndexCount,
                div_id: `pdf_assinatura_${assinaturasIndexCount}`,
                div_id_btn_remover: `assinatura_btn_fechar_${assinaturasIndexCount}`,
                num_page: ass.num_page,
                x: ass.x,
                y: ass.y,
                tipo: ass.tipo,
                icone: "signature",
                pdf_x: ass.pdf_x,
                pdf_y: ass.pdf_y,
            };
            if (ass.tipo === 1) { assinatura_nova.icone = "signature" }
            if (ass.tipo === 2) { assinatura_nova.icone = "gesture" }
            if (ass.tipo === 3) { assinatura_nova.icone = "close" }
            if (ass.tipo === 4) { assinatura_nova.icone = "calendar_today" }
            assinaturas_aux.push(assinatura_nova)
            assinaturasIndexCount++
        }
        return assinaturas_aux
    }
    function parseSignatarios(signatarios: any[]) {
        let sigs: signatarioDadosDto[] = [];
        for (let sig of signatarios) {
            const novo_signatario: signatarioDadosDto = {
                id_signatario: sig.id_signatario,
                id_documento: sig.id_documento,
                id_funcao: sig.id_funcao,
                id_colaborador: sig.id_colaborador,
                nome_completo: sig.nome_completo,
                email: sig.email,
                celular: sig.celular,
                cpf: sig.cpf,
                auth_assinatura: sig.auth_assinatura,
                auth_sms: sig.auth_sms,
                auth_selfie: sig.auth_selfie,
                auth_cpf: sig.auth_cpf,
            };
            sigs.push(novo_signatario);
        }
        return sigs;
    }
    
    async function renderViewDocumento() { 
        try {
           	viewDocumento(documentoDados)
        } catch (error: unknown) {
            console.error(error);
            toast.error("Não foi possível visualizar o documento PDF, atualize a página!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }
    }
    async function viewDocumento(documento: any) {
        // let docView = pdfjsLib.getDocument(documento.original_link)

        parseSignatarioConfigAssinatura(documento.signatarios);

        let painel_canvas = document.getElementById("divs_canvas") as HTMLElement;
        while (painel_canvas.firstChild) {
            painel_canvas.removeChild(painel_canvas.firstChild);
        }

        let painel_assinaturas = document.getElementById("divs_assinaturas") as HTMLElement;
        while (painel_assinaturas.firstChild) {
            painel_assinaturas.removeChild(painel_assinaturas.firstChild);
        }

        let paginas: any[] = [];
        var outputScale = window.devicePixelRatio || 1;
        
        document.getElementById("div_documento_loading")!.style.display = "flex"
        
        getDocument(documento.original_link).promise.then((pdf: PDFDocumentProxy) => {
            let pdf_num_pages = pdf._pdfInfo.numPages;
            criarCanvasPdf(pdf_num_pages);
            for (let npage = 1; npage <= pdf_num_pages; npage++) {
                pdf.getPage(npage).then((page) => {
                    const canvas_html_id = `pdf_canvas_${npage}`;
                    const scale = 1.8;
                    let viewport = page.getViewport({ scale });
                    let viewport_original = page.getViewport({ scale: 1 });
                    var canvas = document.getElementById(canvas_html_id) as HTMLCanvasElement;
                    if (canvas === null) {
                        return;
                    }
                    canvas.width = Math.floor(viewport.width * outputScale);
                    canvas.height = Math.floor(viewport.height * outputScale);
                    canvas.style.width = Math.floor(viewport.width) + "px";
                    canvas.style.height = Math.floor(viewport.height) + "px";
                    var transform: any[] | null = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;

                    paginas.push({
                        num_page: npage,
                        width: canvas.width,
                        height: canvas.height,
                        pdf_width: viewport_original.width,
                        pdf_height: viewport_original.height,
                        viewport: viewport,
                        canvas: canvas,
                        scale,
                    });
                    var context = canvas.getContext("2d");
                    page.render({
                        canvasContext: context as any,
                        transform: transform as any,
                        viewport: viewport,
                        canvas: canvas,
                    }).promise.then(() => {
                        if (npage === pdf_num_pages) {
                            renderPaginasAssinaturas(paginas);
                        }
                    });
                });
            }
        }).catch(async (error) => { 
            console.error(error);
            toast.error("Não foi possível visualizar o documento PDF, atualizando a página!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(2500);
            window.location.reload();
        }).then(() => { 
            document.getElementById("div_documento_loading")!.style.display = "none";
            document.getElementById("btn_salvar_assinaturas")!.style.display = "flex";
        });
    }
    async function renderPaginasAssinaturas(paginasDoc: any[]) {
        let painel_assinaturas = document.getElementById("divs_assinaturas") as HTMLElement;
        while (painel_assinaturas.firstChild) {
            painel_assinaturas.removeChild(painel_assinaturas.firstChild);
        }
        paginasDoc.sort((a, b) => a.num_page - b.num_page);
        document.getElementById("title_definir_assinaturas")!.innerText = `Definir Assinaturas (${paginasDoc.length} Páginas)`
        let positionTop = 0;
        for (let page of paginasDoc) {
            let npage = page.num_page;
            let viewport = page.viewport;
            let div_page_assinatura = document.createElement("div");
            let page_assinatura_id = `pdf_assinaturas_${npage}`;
            div_page_assinatura.setAttribute("id", page_assinatura_id);
            div_page_assinatura.setAttribute("class", "pdfs_assinatura");

            div_page_assinatura.style.left = `0px`;
            div_page_assinatura.style.top = `${positionTop}px`;
            div_page_assinatura.style.width = Math.floor(viewport.width) + "px";
            div_page_assinatura.style.height = Math.floor(viewport.height) + "px";
            div_page_assinatura.addEventListener("click", (event: MouseEvent) => {
                clickPageAssinatura(page_assinatura_id, event);
            });
            painel_assinaturas.appendChild(div_page_assinatura);
            
            positionTop += Math.floor(viewport.height);
            let p_contador_pagina = document.createElement("p")
            p_contador_pagina.setAttribute("class", "pdfs_p_contador_paginas")
            p_contador_pagina.innerText = `Pag. ${npage} de ${paginasDoc.length}`
            p_contador_pagina.style.left = `0px`
            p_contador_pagina.style.top = `${positionTop}px`
            painel_assinaturas.appendChild(p_contador_pagina)
            positionTop += 32;
        }
        paginasDados = paginasDoc;
        await funcSleep(150);
        await renderizarAssinaturas(assinaturasDados, paginasDoc);
    }
    async function renderizarAssinaturas(assinaturasDadosLoading: any[], paginasDoc: any[]) {
        let div_assinaturas = document.querySelectorAll(".div_assinatura") as NodeListOf<Element>;
        for (let div of div_assinaturas) {
            div.remove();
        }
        for (let ass of assinaturasDadosLoading) {
            let div_container_id = `pdf_assinaturas_${ass.num_page}`;
            let signatario = getSignatarioFromDados(ass.id_signatario);
            if (signatario === null) {
                console.log(`signatario === null`);
                continue;
            }
            renderizarNovaAssinatura(ass.id_assinatura, ass.tipo, ass.index, ass.div_id, div_container_id, signatario, ass.icone, ass.x, ass.y);
        }
    }
    function apagarTodasAssinaturas() { 
        if (!window.confirm("Tem certeza que deseja apagar todas assinaturas?")) { 
            return
        }
        try {
            let div_assinaturas = document.querySelectorAll(".div_assinatura") as NodeListOf<Element>;
            for (let div of div_assinaturas) {
                div.remove();
            }
            assinaturasDados = []
            toast.success(`Assinaturas excluídas com sucesso!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        } catch (error: unknown) {
           	console.error(error);
        }
    }
    function criarCanvasPdf(pdf_num_pages: number) {
        let div_canvas = document.getElementById("divs_canvas") as HTMLElement;
        while (div_canvas.firstChild) {
            div_canvas.removeChild(div_canvas.firstChild);
        }
        for (let i = 1; i <= pdf_num_pages; i++) {
            let canvas = document.createElement("canvas");
            canvas.setAttribute("id", `pdf_canvas_${i}`);
            canvas.setAttribute("class", "pdfs_canvas");
            div_canvas!.appendChild(canvas);
        }
    }
    function clickPageAssinatura(div_id: string, event: MouseEvent) {
        let container = document.getElementById(div_id) as HTMLElement;
        if (container !== event.target) {
            console.log(`container !== event.target`);
            return;
        }

        // div_page_assinatura_selecionada = container;
        // assinatura_x = event.offsetX;
        // assinatura_y = event.offsetY;
        defineValueInInput("div_selecionada_aux", `${div_id}/${event.offsetX}/${event.offsetY}`);

        let cLeft = Number(String(container.style.left).replace("px", ""));
        let cTop = Number(String(container.style.top).replace("px", ""));
        let x = event.offsetX + cLeft;
        let y = event.offsetY + cTop;

        let div_config = document.getElementById("div_assinatura_config") as HTMLElement;
        if (div_config.style.display === "inline-block") {
            div_config.style.left = `${x}px`;
            div_config.style.top = `${y}px`;
        }
        if (div_config.style.display === "none" || div_config.style.display === "") {
            div_config.style.display = "inline-block";
            div_config.style.left = `${x}px`;
            div_config.style.top = `${y}px`;
        }
    }
    function assinaturaConfigClose() {
        document.getElementById("div_assinatura_config")!.style.display = "none";
    }
    function parseSignatarioConfigAssinatura(signatarios: any[]) {
        if (signatarios.length === 0) {
            return;
        }
        let input = document.getElementById("config_id_signatario") as HTMLElement;
        while (input.firstChild) {
            input.removeChild(input.firstChild);
        }
        for (let sig of signatarios) {
            let option = document.createElement("option");
            option.innerText = sig.nome_completo;
            option.value = sig.id_signatario;
            input.appendChild(option);
        }
    }

    function handleAdicionarAssinatura(tipo: 1 | 2 | 3 | 4) {
        assinaturaConfigClose();

        let div_selecionada_aux: string = getValueFromInput("div_selecionada_aux");
        let container_div_id = div_selecionada_aux.split("/")[0];
        let event_offsetX = Number(div_selecionada_aux.split("/")[1]);
        let event_offsetY = Number(div_selecionada_aux.split("/")[2]);
        let div_page_assinatura_selecionada = getElementFromId(container_div_id);
        if (div_page_assinatura_selecionada === null) {
            console.log(`div_page_assinatura_selecionada === null`);
            return;
        }
        if (signatariosDados.length === 0) {
            console.log(`signatariosDados.length === 0`);
            return;
        }

        let div_id = `pdf_assinatura_${assinaturasIndexCount}`;
        let div_container_id = div_page_assinatura_selecionada.id;
        let id_signatario = Number(getValueFromInput("config_id_signatario"));
        let signatario = getSignatarioFromDados(id_signatario);
        if (signatario === null) {
            console.log(`signatario === null`);
            return;
        }
        let icone = "signature"
        if (tipo === 1) { icone = "signature" }
        if (tipo === 2) { icone = "gesture" }
        if (tipo === 3) { icone = "close" }
        if (tipo === 4) { icone = "calendar_today" }
        
        try {
            let assinatura_nova = renderizarNovaAssinatura(null, tipo, assinaturasIndexCount, div_id, div_container_id, signatario, icone, event_offsetX, event_offsetY);
            let ass_aux: any[] = [];
            for (let ass of assinaturasDados) {
                ass_aux.push(ass);
            }
            ass_aux.push(assinatura_nova);
            assinaturasIndexCount++
            assinaturasDados = ass_aux
        } catch (error: unknown) {
            console.error(error);
            toast.warning(`Erro ao tentar adicionar assinatura!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }
    }
    function renderizarNovaAssinatura(id_assinatura: number | null, tipo: 1 | 2 | 3 | 4, index: number, div_id: string, div_container_id: string, signatario: any, icone: string, div_x: number, div_y: number): any {
        let div_page_assinatura = document.getElementById(div_container_id) as HTMLElement;
        let div_assinatura = document.createElement("div");
        div_assinatura.setAttribute("id", div_id);
        div_assinatura.setAttribute("class", "div_assinatura");
        div_assinatura.addEventListener("mousedown", (event: MouseEvent) => {
            startMoving(div_assinatura, div_container_id, event);
        });
        div_assinatura.addEventListener("mouseup", (event: MouseEvent) => {
            stopMoving(div_assinatura, div_container_id);
        });
        let div_ass_width = 180;
        let div_ass_height = 130;
        let div_icon_label = ""
        if (tipo === 1) { 
            div_icon_label = "Assinatura"
        }
        if (tipo === 2) { 
            div_icon_label = "Visto"
        }
        if (tipo === 3) { 
            div_ass_width = 70;
            div_ass_height = 65;
        }
        if (tipo === 4) { 
            div_ass_width = 170;
            div_ass_height = 40;
        }
        div_assinatura.style.width = `${div_ass_width}px`;
        div_assinatura.style.height = `${div_ass_height}px`;
        div_assinatura.innerHTML = `
            <div>
                <p class="div_assinatura_p">${signatario.nome_completo}</p>
                <br>
                <div>
                    <p>${div_icon_label}</p>
                    <span class="material-symbols-outlined div_assinatura_icon">
                    ${icone}
                </span>
                </div>
            </div>
        `;
        if (tipo === 3) { 
            div_assinatura.innerHTML = `
                <div>
                    <span class="material-symbols-outlined div_assinatura_icon" style="color: red;">
                        ${icone}
                    </span>
                </div>
            `
        }
        if (tipo === 4) { 
            div_assinatura.style.padding = `3px`;
            div_assinatura.innerHTML = `
                <div class="div-row">
                    <span class="material-symbols-outlined div_assinatura_icon">
                        ${icone}
                    </span>
                    &nbsp;
                    <p>Data Assinado</p>
                    <div id="assinatura_btn_fechar_${index}" class="material-symbols-outlined div_assinatura_fechar_icon">
                        close
                    </div>
                </div>
            `
        }
        
        // Botão de DELETAR assinatura
        let div_assinatura_btn_fechar = document.createElement("div");
        div_assinatura_btn_fechar.setAttribute("class", "div_assinatura_fechar");
        let id_btn_remover_assinatura = `assinatura_btn_fechar_${index}`;
        if (tipo === 1 || tipo === 2) { 
            let div_assinatura_btn_fechar_span = document.createElement("span");
            div_assinatura_btn_fechar_span.setAttribute("id", id_btn_remover_assinatura);
            div_assinatura_btn_fechar_span.innerText = "close";
            div_assinatura_btn_fechar_span.setAttribute("class", "material-symbols-outlined div_assinatura_fechar_icon");
            div_assinatura_btn_fechar.appendChild(div_assinatura_btn_fechar_span);
        }
        if (tipo === 3) { 
            let div_assinatura_btn_fechar_paragrafo = document.createElement("p");
            div_assinatura_btn_fechar_paragrafo.setAttribute("id", id_btn_remover_assinatura);
            div_assinatura_btn_fechar_paragrafo.innerText = "Remover";
            div_assinatura_btn_fechar_paragrafo.setAttribute("class", "div_assinatura_fechar_icon");
            div_assinatura_btn_fechar_paragrafo.style.fontSize = "10px"
            div_assinatura_btn_fechar.appendChild(div_assinatura_btn_fechar_paragrafo);
        }
        div_assinatura.appendChild(div_assinatura_btn_fechar);
        // Botão de COPIAR assinatura
        let div_assinatura_btn_copiar = document.createElement("div")
        div_assinatura_btn_copiar.setAttribute("class", "div_assinatura_copy")
        let div_assinatura_btn_copiar_span = document.createElement("span")
        let id_btn_copiar_assinatura = `assinatura_btn_copiar_${index}`
        div_assinatura_btn_copiar_span.setAttribute("id", id_btn_copiar_assinatura)
        div_assinatura_btn_copiar_span.innerText = "content_copy"
        div_assinatura_btn_copiar_span.setAttribute("class", "material-symbols-outlined div_assinatura_copy_icon")
        div_assinatura_btn_copiar.appendChild(div_assinatura_btn_copiar_span)
        if (tipo === 1 || tipo === 2) { 
            div_assinatura.appendChild(div_assinatura_btn_copiar)
        }

        // Adicionar assinatura para a visualização da página
        div_assinatura.style.left = `${div_x}px`;
        div_assinatura.style.top = `${div_y}px`;
        div_page_assinatura.appendChild(div_assinatura);

        let pos_num_page = Number(String(div_container_id).split("_")[2]);
        let paginasAux: any[] = paginasDados.filter((reg: any) => reg.num_page === pos_num_page);
        let page = paginasAux.length === 0 ? null : paginasAux[0];
        if (page === null) {
            console.log(`page === null`);
            return;
        }

        let dist_x_quadro_assinatura = div_ass_width/4
        let xViewport = (div_x - dist_x_quadro_assinatura) / page.scale;
        let dist_y_quadro_assinatura = div_y + div_ass_height
        let yViewport = (page.height - dist_y_quadro_assinatura) / page.scale;
        if (tipo === 3) { 
            dist_x_quadro_assinatura = div_ass_width/2
            xViewport = (div_x + dist_x_quadro_assinatura) / page.scale;
            xViewport -= 8
            dist_y_quadro_assinatura = div_y + (div_ass_height / 2)
            yViewport = (page.height - dist_y_quadro_assinatura) / page.scale;
            yViewport -= 11
        }

        let assinatura_nova = {
            id_assinatura: id_assinatura,
            id_documento: documentoDados.id,
            id_signatario: signatario.id_signatario,
            index: index,
            div_id: div_id,
            div_id_btn_remover: id_btn_remover_assinatura,
            div_id_btn_copiar: id_btn_copiar_assinatura,
            num_page: pos_num_page,
            x: div_x,
            y: div_y,
            tipo: tipo,
            icone: icone,
            pdf_x: xViewport,
            pdf_y: yViewport,
        };
        definirComportamentoBtnRemoverAssinaturas(assinatura_nova);
        return assinatura_nova;
    }
    function definirComportamentoBtnRemoverAssinaturas(assinatura: any) {
        let div_id_container = assinatura.div_id;
        let div_id_btn_remover = assinatura.div_id_btn_remover;
        let div_id_btn_copiar = assinatura.div_id_btn_copiar;
        let btn_remover = document.getElementById(div_id_btn_remover) as HTMLElement;
        btn_remover.addEventListener("mouseup", (event: MouseEvent) => {
            try {
                deletarAssinatura(div_id_container);
            } catch (error: unknown) {
                console.error(error);
                toast.warning(`Erro ao tentar deletar assinatura!`, {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
            }
        });
        if (assinatura.tipo === 1 || assinatura.tipo === 2) { 
            let btn_copiar = document.getElementById(div_id_btn_copiar) as HTMLElement;
            btn_copiar.addEventListener("mouseup", (event: MouseEvent) => { 
                try {
                    assinaturasDados = copiarAssinatura(assinatura, paginasDados);
                } catch (error: unknown) {
                    console.error(error);
                    toast.warning(`Erro ao tentar copiar assinatura!`, {
                        containerId: 1,
                        position: "top-center",
                        theme: "dark",
                    });
                }
            })
        }
    }
    function getSignatarioFromDados(id_signatario: number): signatarioDadosDto | null {
        let pesquisa = signatariosDados.filter((reg) => reg.id_signatario === id_signatario);
        if (pesquisa.length === 0) {
            return null;
        }
        return pesquisa[0];
    }
    function atualizarPosAssinaturaById(div_id: any, posX: any, posY: any) {
        let dados_aux:any[] = []
        for (let reg of assinaturasDados) {
            if (reg.div_id === div_id) {
                let pos_num_page = reg.num_page;
                let paginasAux: any[] = paginasDados.filter((reg: any) => reg.num_page === pos_num_page);
                let page = paginasAux.length === 0 ? null : paginasAux[0];
                if (page === null) {
                    console.log(`page === null`)
                    return;
                }
                let tipo = reg.tipo
                let div_ass_width = 180;
                let div_ass_height = 130;
                if (tipo === 3) { 
                    div_ass_width = 70;
                    div_ass_height = 65;
                }
                if (tipo === 4) { 
                    div_ass_width = 170;
                    div_ass_height = 40;
                }

                let dist_x_quadro_assinatura = div_ass_width/4
                let xViewport = (posX - dist_x_quadro_assinatura) / page.scale;
                let dist_y_quadro_assinatura = posY + div_ass_height
                let yViewport = (page.height - dist_y_quadro_assinatura) / page.scale;
                if (tipo === 3) { 
                    dist_x_quadro_assinatura = div_ass_width/2
                    xViewport = (posX + dist_x_quadro_assinatura) / page.scale;
                    xViewport -= 8
                    dist_y_quadro_assinatura = posY + (div_ass_height / 2)
                    yViewport = (page.height - dist_y_quadro_assinatura) / page.scale;
                    yViewport -= 11
                }
                if (tipo === 4) { 
                    dist_x_quadro_assinatura = div_ass_width/2
                    xViewport = (posX + 10) / page.scale;
                    dist_y_quadro_assinatura = posY + (div_ass_height / 2)
                    yViewport = (page.height - dist_y_quadro_assinatura) / page.scale;
                    yViewport -= 3
                }

                reg.x = posX;
                reg.y = posY;
                reg.pdf_x = xViewport;
                reg.pdf_y = yViewport;
            }
            dados_aux.push(reg)
        }
        assinaturasDados = dados_aux
    }
    function move(divid: any, xpos: any, ypos: any) {
        divid.style.left = `${xpos}px`;
        divid.style.top = `${ypos}px`;
    }
    function startMoving(divid: any, container: any, evt: any) {
        evt = evt || window.event;
        container = document.getElementById(container);

        let posX = evt.clientX;
        let posY = evt.clientY;
        let divTop = divid.style.top;
        let divLeft = divid.style.left;
        let eWi = parseInt(divid.style.width);
        let eHe = parseInt(divid.style.height);
        let cWi = parseInt(container.style.width);
        let cHe = parseInt(container.style.height);

        divTop = divTop.replace("px", "");
        divLeft = divLeft.replace("px", "");
        let diffX = posX - divLeft;
        let diffY = posY - divTop;

        document.onmousemove = function (evt) {
            evt = evt || window.event;

            let posX = evt.clientX;
            let posY = evt.clientY;
            let aX = posX - diffX;
            let aY = posY - diffY;
            if (aX < 0) aX = 0;
            if (aY < 0) aY = 0;
            if (aX + eWi > cWi) aX = cWi - eWi;
            if (aY + eHe > cHe) aY = cHe - eHe;

            move(divid, aX, aY);
        };
    }
    function stopMoving(divid: any, container: any) {
        document.getElementById(container)!.style.cursor = "default";
        document.onmousemove = function () {};

        let divTop = divid.style.top;
        let divLeft = divid.style.left;
        divTop = Number(divTop.replace("px", ""));
        divLeft = Number(divLeft.replace("px", ""));

        try {
            atualizarPosAssinaturaById(divid.id, divLeft, divTop);
        } catch (error: unknown) {
            console.error(error);
        }
    }
    function deletarAssinatura(div_id_container: string) {
        let div_assinatura = document.getElementById(div_id_container);
        if (div_assinatura === null) {
            console.log(`div_assinatura === null`);
            return;
        }
        div_assinatura.remove();
        let assinaturasAux: any[] = [];
        for (let ass of assinaturasDados) {
            if (ass.div_id === div_id_container) {
                continue;
            }
            assinaturasAux.push(ass);
        }
        assinaturasDados = assinaturasAux
    }
    function copiarAssinatura(ass: any, paginasDoc: any[]) {
        let pagina_inicial = ass.num_page
        pagina_inicial++
        if (pagina_inicial > paginasDoc.length) {
            console.log(`pagina_inicial > paginasDados.length`)
            console.log(`${pagina_inicial} > ${paginasDados.length}`)
            toast.warning(`Nenhuma assinatura copiada, última página do documento!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            return assinaturasDados
        }
        let id_signatario = ass.id_signatario;
        let signatario = getSignatarioFromDados(id_signatario);
        handleLoadingStatus(true)
        for (let npage = pagina_inicial; npage <= paginasDoc.length; npage++) { 
            let div_id = `pdf_assinatura_${assinaturasIndexCount}`;
            let div_container_id = `pdf_assinaturas_${npage}`;
            let assinatura_nova = renderizarNovaAssinatura(null, ass.tipo, assinaturasIndexCount, div_id, div_container_id, signatario, ass.icone, ass.x, ass.y);
            assinaturasDados.push(assinatura_nova)
            assinaturasIndexCount++
            // await funcSleep(100)
        }
        console.log(assinaturasDados)
        handleLoadingStatus(false)
        let qtd_paginas = paginasDoc.length - ass.num_page
        toast.success(`Copiado assinatura com sucesso para as próximas ${qtd_paginas} páginas.`, {
            containerId: 1,
            position: "top-center",
            theme: "dark",
        });
        return assinaturasDados
    }

    function handleBtnAdicionarAssinatura(tipo_config: string) { 
        let input_id = `config_assinatura_tipo`
        if (tipo_config === "outros") { input_id = "config_assinatura_outros" }
        let tipo_assinatura = Number(getValueFromInput(input_id))
        if (tipo_assinatura === 1) { handleAdicionarAssinatura(1) }
        if (tipo_assinatura === 2) { handleAdicionarAssinatura(2) }
        if (tipo_assinatura === 3) { handleAdicionarAssinatura(3) }
        if (tipo_assinatura === 4) { handleAdicionarAssinatura(4) }
    }

    return (
        <div id="documento_assinaturas">
            <div className="div-row" style={{justifyContent: "space-between", width: "100%"}}>
                <h2 id="title_definir_assinaturas">Definir Assinaturas</h2>
                <Button variant={"danger"} size={"sm"} onClick={() => apagarTodasAssinaturas()}>Apagar Tudo</Button>
            </div>
            <br></br>
            <div className="div-row" id="div_documento_loading">
                <p style={{marginRight: "15px"}}>Carregando documento...</p>
                <Spinner></Spinner>
            </div>
            <div id="div_documento_view">
                <div id="div_assinatura_config">
                    <span className="material-symbols-outlined" id="btn_close_config" onClick={() => assinaturaConfigClose()}>
                        close
                    </span>
                    <br></br>
                    <select className="form-select" aria-label="Default select example" id="config_id_signatario"></select>
                    <br></br>
                    <p>Tipo de Assinatura:</p>
                    <div className="div-row" style={{width: "100%", justifyContent: "space-between"}}>
                        <div style={{width: "65%"}}>
                            <select className="form-select" id="config_assinatura_tipo">
                                <option value={1}>Assinatura</option>
                                <option value={2}>Visto</option>
                            </select>
                        </div>
                        <div>
                            <Button variant={"secondary"} onClick={() => handleBtnAdicionarAssinatura("assinatura")}>OK</Button>
                        </div>
                    </div>
                    <br></br>
                    <p>Outros:</p>
                    <div className="div-row" style={{width: "100%", justifyContent: "space-between"}}>
                        <div style={{width: "65%"}}>
                            <select className="form-select" id="config_assinatura_outros">
                                <option value={3}>Marcar X</option>
                                <option value={4}>D. Assinado</option>
                            </select>
                        </div>
                        <div>
                            <Button variant={"secondary"} onClick={() => handleBtnAdicionarAssinatura("outros")}>OK</Button>
                        </div>
                    </div>
                </div>
                <div id="divs_canvas"></div>
                <div id="divs_assinaturas"></div>
                <br></br>
            </div>
            <div id="documento_controles" className="div-row" style={divControls}>
                {/*<Button onClick={() => renderViewDocumento()} style={divButtonsControls}>Renderizar</Button>*/}
                <Button onClick={() => handleUpdate(assinaturasDados)} style={{marginRight: "10px", display: "none"}} variant="success" id="btn_salvar_assinaturas" className="div-row-space-between">Salvar Assinaturas &nbsp;<span className="material-symbols-outlined">save</span></Button>
            </div>
        </div>
    );
}
interface iProps {
    handleUpdate: any;
    handleLoadingStatus: any;
}
const divControls:React.CSSProperties = {
    width: "auto",
    position: "fixed",
    left: "18%",
    bottom: "10px",
    zIndex: 99,
    // backgroundColor: "grey",
}
// const divButtonsControls:React.CSSProperties = {
//     marginRight: "10px",
// }
